import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthSession } from "../apis/Auth";
import { clearGuestAccess, getGuestAccessState, lockGuestAccess } from "../utils/guestAccess";

const formatTwoDigits = (value) =>
  Math.max(0, value).toString().padStart(2, "0");

export default function RequireAuth({ children }) {
  const location = useLocation();
  const authQuery = useAuthSession();
  const [status, setStatus] = useState("loading");
  const [remainingMs, setRemainingMs] = useState(0);

  useEffect(() => {
    if (authQuery.isLoading) {
      setStatus("loading");
      return undefined;
    }

    let active = true;
    let expireTimer;
    let countdownTimer;

    if (authQuery.data?.authenticated) {
      clearGuestAccess();
      setStatus("authenticated");
      setRemainingMs(0);
      return undefined;
    }

    const guestAccess = getGuestAccessState();
    if (!active) return undefined;

    if (guestAccess.status === "expired") {
      setStatus("expired");
      setRemainingMs(0);
      return undefined;
    }

    setStatus("guest");
    setRemainingMs(Math.max(guestAccess.expiresAt - Date.now(), 0));
    countdownTimer = window.setInterval(() => {
      if (!active) return;
      setRemainingMs(Math.max(guestAccess.expiresAt - Date.now(), 0));
    }, 1000);
    expireTimer = window.setTimeout(() => {
      if (!active) return;
      lockGuestAccess();
      setRemainingMs(0);
      setStatus("expired");
    }, Math.max(guestAccess.expiresAt - Date.now(), 0));

    return () => {
      active = false;
      if (expireTimer) {
        window.clearTimeout(expireTimer);
      }
      if (countdownTimer) {
        window.clearInterval(countdownTimer);
      }
    };
  }, [authQuery.data?.authenticated, authQuery.isLoading]);

  if (status === "loading") {
    return null;
  }

  if (status === "expired") {
    return (
      <Navigate
        to="/pages/signin"
        replace
        state={{ from: location, reason: "expired" }}
      />
    );
  }

  return (
    <>
      {status === "guest" && (
        <div
          style={{
            position: "fixed",
            top: "76px",
            right: "16px",
            zIndex: 1200,
            padding: "8px 12px",
            borderRadius: "999px",
            backgroundColor: "rgba(15, 23, 42, 0.9)",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.01em",
            boxShadow: "0 8px 20px rgba(0, 0, 0, 0.18)",
          }}
        >
          로그인 제한까지 남은 시간: {formatTwoDigits(Math.floor(remainingMs / 60000))}:{formatTwoDigits(Math.floor((remainingMs % 60000) / 1000))}
        </div>
      )}
      {children}
    </>
  );
}
